"use client";
import React from "react";
import dynamic from "next/dynamic";

let ContactHero = dynamic(() => import("./ContactHero"), {
  ssr: false,
});

let Contact = dynamic(() => import("../pages/web/(web)/home/Contact"), {
  ssr: false,
});

export default function page() {
  return (
    <>
      <ContactHero />
      <Contact />
    </>
  );
}
